var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.steps),function(idx){return _c('div',{key:("step-" + idx),staticClass:"row items-center q-ml-md"},[_c('q-avatar',{staticClass:"w-700",attrs:{"color":_vm.current == idx
          ? 'default'
          : idx < _vm.current
          ? 'np-primary-1100'
          : 'disable',"text-color":"white","size":_vm.size}},[_vm._v(" "+_vm._s(_vm.stepStatus(idx))+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }